// src/utils/loader.ts

export function showLoader() {
  const loader = document.querySelector("loading-screen") as HTMLElement | null;
  if (loader) loader.style.display = "flex";
}

export function hideLoader() {
  const loader = document.querySelector("loading-screen") as HTMLElement | null;
  if (loader) loader.style.display = "none";
}
